export default {
    data (){
        return {
            _drawTarget: undefined
        }
    },

    methods: {
        _cancelDraw (){
            if(this._drawTarget){
                this._drawTarget.complete();

                this._drawTarget = undefined;
            }
        },

        _clearAllDraw() {
            (DrawBase._overlays[this.mapId] || []).forEach(item => {
                this.getMapInstance().removeOverlay(item);
            });

            DrawBase._overlays[this.mapId] = [];

            DrawBase._pointMap[this.mapId] = {};
        },

        _drawMarker(marker, callback, echoData, styleOptions) {
            this._drawTarget = new DrawMarker({
                vm: this,
                mapInstance: this.getMapInstance(),
                MapAPI: this.MapAPI,
                markerName: marker,
                callback,
                echoData,
                styleOptions
            });
        },

        _drawCircular(color, callback, echoData, styleOptions) {
            this._drawTarget = new DrawCircular({
                vm: this,
                mapInstance: this.getMapInstance(),
                MapAPI: this.MapAPI,
                color,
                callback,
                echoData,
                styleOptions
            });
        },

        _drawLine(color, callback, echoData, styleOptions) {
            this._drawTarget = new DrawLine({
                vm: this,
                mapInstance: this.getMapInstance(),
                MapAPI: this.MapAPI,
                color,
                callback,
                echoData,
                styleOptions
            });
        },

        _drawPolygon(color, callback, echoData, styleOptions) {
            this._drawTarget = new DrawPolygon({
                vm: this,
                mapInstance: this.getMapInstance(),
                MapAPI: this.MapAPI,
                color,
                callback,
                echoData,
                styleOptions
            });
        },

        _drawRectangle(color, callback, echoData, styleOptions) {
            this._drawTarget = new DrawRectangle({
                vm: this,
                mapInstance: this.getMapInstance(),
                MapAPI: this.MapAPI,
                color,
                callback,
                echoData,
                styleOptions
            });
        }
    }
}

class DrawBase {
    static _overlays = {};
    static _pointMap = {};

    pointList = [];
    mapmapInstance = undefined;
    MapAPI = undefined;
    defaultColor = 'red';
    markerName = undefined;
    handleMoveBoundProxy = undefined;
    handleMoveOutProxy = undefined;
    callback = undefined;
    isAutoMove = false;
    styleOptions = {
        // strokeColor: 'red',    //边线颜色。
        // fillColor: 'red',      //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 2,       //边线的宽度，以像素为单位。
        strokeOpacity: 1,	   //边线透明度，取值范围0 - 1。
        fillOpacity: .7,      //填充的透明度，取值范围0 - 1。
        strokeStyle: 'solid' //边线的样式，solid或dashed。
    };

    constructor({vm, mapInstance, MapAPI, color, markerName, callback, echoData = [], styleOptions = {}}) {
        this.vm = vm;
        this.mapmapInstance = mapInstance;
        this.MapAPI = MapAPI;
        this.markerName = markerName;
        this.callback = callback;
        this.pointList = [[]];

        DrawBase._overlays[this.vm.mapId] = [];
        DrawBase._pointMap[this.vm.mapId] = {};

        Object.assign(this.styleOptions, {
            strokeColor: color || this.defaultColor,
            fillColor: color || this.defaultColor
        }, styleOptions);

        this.mapmapInstance.setDefaultCursor("crosshair");

        this.handleMoveBoundProxy = this._handleMapMoveBound.bind(this);

        this.handleMoveOutProxy = this._handleMoveOut.bind(this);

        this.mapmapInstance.addEventListener('mousemove', this.handleMoveBoundProxy);

        this.mapmapInstance.addEventListener('onmouseout', this.handleMoveOutProxy);

        this.init();

        if(echoData && echoData.length > 0){
            this.handleEcho(echoData);
        }else{
            this.start();
        }
    }

    handleEcho (){}

    init (){}

    start (){}

    destroy (){}

    complete (){
        this.isAutoMove = false;

        this.mapmapInstance.setDefaultCursor("url('bird.cur')");

        this.mapmapInstance.removeEventListener('mousemove', this.handleMoveBoundProxy);

        this.mapmapInstance.removeEventListener('onmouseout', this.handleMoveOutProxy);

        this._edgeMoveTimer && clearInterval(this._edgeMoveTimer);

        this.destroy();
    }

    _handleMoveOut (e){
        this._edgeMoveTimer && clearInterval(this._edgeMoveTimer);
    }

    _handleMapMoveBound (e){
        if(!this.isAutoMove){
            return;
        }

        let pixel = this.mapmapInstance.pointToPixel(this._getDrawPoint(e)),
            clientPos = this._getClientPosition(e),
            offsetX = clientPos.x - pixel.x,
            offsetY = clientPos.y - pixel.y;
        pixel = new this.MapAPI.Pixel((clientPos.x - offsetX), (clientPos.y - offsetY));

        // 拖拽到地图边缘移动地图
        this._panByX = this._panByY = 0;
        if (pixel.x <= 20 || pixel.x >= this.mapmapInstance.width - 20
            || pixel.y <= 50 || pixel.y >= this.mapmapInstance.height - 10) {
            if (pixel.x <= 20) {
                this._panByX = 8;
            } else if (pixel.x >= this.mapmapInstance.width - 20) {
                this._panByX = -8;
            }
            if (pixel.y <= 50) {
                this._panByY = 8;
            } else if (pixel.y >= this.mapmapInstance.height - 10) {
                this._panByY = -8;
            }
            if (!this._edgeMoveTimer) {
                this._edgeMoveTimer = setInterval(() => {
                    this.mapmapInstance.panBy(this._panByX, this._panByY, { "noAnimation": true });
                }, 30);
            }
        } else {
            if (this._edgeMoveTimer) {
                clearInterval(this._edgeMoveTimer);
                this._edgeMoveTimer = null;
            }
        }
    }

    _getClientPosition (e){
        let clientX = e.clientX,
            clientY = e.clientY;
        if (e.changedTouches) {
            clientX = e.changedTouches[0].clientX;
            clientY = e.changedTouches[0].clientY;
        }
        return new this.MapAPI.Pixel(clientX, clientY);
    }

    _getEventTarget = event => event.target || event.srcElement;

    _getDrawPoint (e){
        let trigger = this._getEventTarget(e),
            x = e.offsetX || e.layerX || 0,
            y = e.offsetY || e.layerY || 0;
        if (trigger.nodeType !== 1) trigger = trigger.parentNode;
        while (trigger && trigger !== this.mapmapInstance.getContainer()) {
            if (!(trigger.clientWidth === 0 &&
                trigger.clientHeight === 0 &&
                trigger.offsetParent && trigger.offsetParent.nodeName === 'TD')) {
                x += trigger.offsetLeft || 0;
                y += trigger.offsetTop || 0;
            }
            trigger = trigger.offsetParent;
        }
        let pixel = new this.MapAPI.Pixel(x, y);
        return this.mapmapInstance.pixelToPoint(pixel);
    }

    _addOverlay (overlay){
        if(overlay){
            this.mapmapInstance.addOverlay(overlay);

            let index = DrawBase._overlays[this.vm.mapId].length;

            DrawBase._overlays[this.vm.mapId].push(overlay);

            //创建右键菜单
            let markerMenu = new this.MapAPI.ContextMenu();

            markerMenu.addItem(new this.MapAPI.MenuItem('删除当前覆盖物', () => {
                this.mapmapInstance.removeOverlay(overlay);

                DrawBase._overlays[this.vm.mapId].splice(index, 1);

                DrawBase._pointMap[this.vm.mapId][this.name].splice(index, 1);

                this.callback(DrawBase._pointMap[this.vm.mapId][this.name], this.name);
            }));

            overlay.addContextMenu && overlay.addContextMenu(markerMenu);
        }
    }

    _getRectanglePoint (startPoint, endPoint) {
        return [
            new this.MapAPI.Point(startPoint.lng, startPoint.lat),
            new this.MapAPI.Point(endPoint.lng, startPoint.lat),
            new this.MapAPI.Point(endPoint.lng, endPoint.lat),
            new this.MapAPI.Point(startPoint.lng, endPoint.lat)
        ];
    }
}

//画点位
class DrawMarker extends DrawBase{
    init() {
        this.name = 'marker';

        this.handleStartProxy = this.handlerStart.bind(this);
    }

    handleEcho (echoData){
        echoData.forEach(item => {
            let point = new this.MapAPI.Point(item.lng, item.lat);

            this.handlerStart({ point });

        });
    }

    start (){
        this.mapmapInstance.addEventListener('click', this.handleStartProxy);
    }

    handlerStart (event){
        this.pointList = [[]];

        let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

        cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

        let icon = this.markerName ? new this.MapAPI.Icon(require(`@/assets/city-map/icon/${this.markerName}.png`), new this.MapAPI.Size(25,25), {
            imageSize: new this.MapAPI.Size(25,25),
            anchor: new this.MapAPI.Size(13, 25)
        }) : undefined;

        let marker = new this.MapAPI.Marker(event.point, { icon });

        super._addOverlay(marker);

        this.pointList[this.pointList.length - 1].push(event.point);

        DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

        this.callback && this.callback(this.pointList, this.name, marker);
    }

    destroy (){
        this.mapmapInstance.removeEventListener('click', this.handleStartProxy);
    }
}

//画圆
class DrawCircular extends DrawBase{
    init() {
        this.name = 'circular';
        this.centerPoint = undefined;
        this.circlemapInstance = undefined;

        this.handleStartProxy = this.handlerStart.bind(this);
        this.handleMousemoveProxy = this.handleMousemove.bind(this);
    }

    handleEcho (echoData){
        let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

        cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

        echoData.forEach(item => {
            let point = new this.MapAPI.Point(item.lng, item.lat);

            super._addOverlay(new this.MapAPI.Circle(point, item.radius, this.styleOptions));

            this.pointList[this.pointList.length - 1].push(item);
        });

        this.callback && this.callback(this.pointList, this.name);

        DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

        this.complete();
    }


    start (){
        this.mapmapInstance.addEventListener('click', this.handleStartProxy);
    }

    handlerStart(event) {
        if(this.centerPoint){
            this.isAutoMove = false;

            this.pointList = [[]];

            let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

            cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

            this.pointList[this.pointList.length - 1].push({
                radius: this.mapmapInstance.getDistance(this.centerPoint, event.point),
                lat: this.centerPoint.lat,
                lng: this.centerPoint.lng
            });

            DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

            this.callback && this.callback(this.pointList, this.name);

            this.centerPoint = undefined;

            this.circlemapInstance = undefined;

            this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
        }else{
            this.isAutoMove = true;

            this.centerPoint = event.point;
            this.circlemapInstance = new this.MapAPI.Circle(this.centerPoint, 0, this.styleOptions);
            super._addOverlay(this.circlemapInstance);

            this.mapmapInstance.addEventListener('mousemove', this.handleMousemoveProxy);
        }
    }

    handleMousemove (event){
        this.circlemapInstance.setRadius(this.mapmapInstance.getDistance(this.centerPoint, event.point));
    }

    destroy() {
        this.mapmapInstance.removeEventListener('click', this.handleStartProxy);
        this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
    }
}

//画线
class DrawLine extends DrawBase{
    init (){
        this.name = 'line';
        this.points = [];
        this.drawPoint = [];
        this.overlay = undefined;

        this.handleStartProxy = this.handleStart.bind(this);
        this.handleMousemoveProxy = this.handleMousemove.bind(this);
        this.handleDblclickProxy = this.handleDblclick.bind(this);
    }

    handleEcho (echoData){
        echoData.forEach(item => {
            let point = new this.MapAPI.Point(item.lng, item.lat);

            this.handleStart({ point });
        });

        this.handleDblclick();

        this.complete();
    }

    start (){
        this.mapmapInstance.addEventListener('click', this.handleStartProxy);
    }

    createOverlay (){
        return new this.MapAPI.Polyline(this.drawPoint, this.styleOptions);
    }

    handleStart (event){
        this.isAutoMove = true;

        this.points.push(event.point);
        this.drawPoint = this.points.concat(this.points[this.points.length - 1]);

        if (this.points.length === 1) {
            this.pointList = [[]];

            let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

            cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

            this.overlay = this.createOverlay();

            super._addOverlay(this.overlay, this.styleOptions);

            this.mapmapInstance.disableDoubleClickZoom();

            this.mapmapInstance.addEventListener('mousemove', this.handleMousemoveProxy);
            this.mapmapInstance.addEventListener('dblclick', this.handleDblclickProxy);
        } else {
            this.overlay.setPath(this.drawPoint);
        }
    }

    handleMousemove (event){
        this.overlay.setPositionAt(this.drawPoint.length - 1, event.point);
    }

    handleDblclick (event){
        this.isAutoMove = false;

        this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
        this.mapmapInstance.removeEventListener('dblclick', this.handleDblclickProxy);
        this.mapmapInstance.enableDoubleClickZoom();

        this.overlay.setPath(this.points);

        this.pointList[this.pointList.length - 1].push(...this.points);

        DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

        this.callback && this.callback(this.pointList, this.name);

        this.overlay = undefined;
        this.points = [];
        this.drawPoint = [];
    }

    destroy() {
        this.mapmapInstance.removeEventListener('click', this.handleStartProxy);
        this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
        this.mapmapInstance.removeEventListener('dblclick', this.handleDblclickProxy);
        this.mapmapInstance.enableDoubleClickZoom();
    }
}

//画多边形
class DrawPolygon extends DrawLine{
    init() {
        super.init();

        this.name = 'polygon';
    }

    createOverlay() {
        return new this.MapAPI.Polygon(this.drawPoint, this.styleOptions);
    }
}

//画矩形
class DrawRectangle extends DrawBase{
    init() {
        this.name = 'rectangle';
        this.startPoint = undefined;
        this.polygon = undefined;

        this.handleStartProxy = this.handleStart.bind(this);
        this.handleMousemoveProxy = this.handleMousemove.bind(this);
    }

    handleEcho (echoData){
        if(!echoData || echoData.length === 0){
            return;
        }

        let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

        cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

        echoData.forEach(item => {
            super._addOverlay(new this.MapAPI.Polygon(item.map(it => {
                let point = new this.MapAPI.Point(it.lng, it.lat);

                this.pointList[this.pointList.length - 1].push(point);

                return point;
            }), this.styleOptions));
        });

        this.callback && this.callback(this.pointList, this.name);

        DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

        this.complete();
    }

    start() {
        this.mapmapInstance.addEventListener('click', this.handleStartProxy);
    }

    handleStart (event){
        if(this.polygon){
            this.isAutoMove = false;

            this.pointList[this.pointList.length - 1].push(...this._getRectanglePoint(this.startPoint, event.point));

            DrawBase._pointMap[this.vm.mapId][this.name] = this.pointList;

            this.callback && this.callback(this.pointList, this.name);

            this.startPoint = undefined;
            this.polygon = undefined;

            this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
        }else{
            this.pointList = [[]];

            let cachePointList = DrawBase._pointMap[this.vm.mapId][this.name] || [];

            cachePointList.length > 0 ? this.pointList.splice(0, 0, ...cachePointList) : this.pointList;

            this.isAutoMove = true;

            this.startPoint = event.point;
            let endPoint = this.startPoint;

            this.polygon = new this.MapAPI.Polygon(this._getRectanglePoint(this.startPoint, endPoint), this.styleOptions);

            super._addOverlay(this.polygon);

            this.mapmapInstance.addEventListener('mousemove', this.handleMousemoveProxy);
        }
    }

    handleMousemove (event){
        this.polygon.setPath(this._getRectanglePoint(this.startPoint, event.point));
    }

    destroy() {
        this.mapmapInstance.removeEventListener('click', this.handleStartProxy);
        this.mapmapInstance.removeEventListener('mousemove', this.handleMousemoveProxy);
    }
}



// WEBPACK FOOTER //
// ./src/components/map/support/drawing.js